import initData from 'init-data';

const isEnabled = featureSwitch => {
    return (
        initData &&
        initData.featureSwitches &&
        initData.featureSwitches[featureSwitch]
    );
};

export const isSwedishOrUndefined = languageCodeIso2 =>
    languageCodeIso2 === undefined || languageCodeIso2.toLowerCase() === 'sv';

export const getLanguageFromCountryCode = countryCodeIso2 => {
    countryCodeIso2 = countryCodeIso2?.toLowerCase();
    if (!countryCodeIso2 || countryCodeIso2 === 'se') {
        return 'sv';
    }
    const languageMap = {};
    if (isEnabled('danish-where-available')) {
        languageMap.dk = 'da';
    }
    if (isEnabled('german-where-available')) {
        languageMap.de = 'de';
    }
    return languageMap[countryCodeIso2] || 'en';
};
